/**
 * Google Analytics (GA4) helpers. Requires the gtag script in index.html.
 */
export const GA_MEASUREMENT_ID = 'G-E1G1KWWBK8';

declare global {
  interface Window {
    gtag?: (
      command: 'config' | 'event' | 'js',
      targetId: string,
      params?: Record<string, unknown>
    ) => void;
    dataLayer?: unknown[];
  }
}

export function pageView(path: string, title?: string): void {
  if (typeof window.gtag !== 'function') return;
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path,
    ...(title && { page_title: title }),
  });
}

export function event(
  name: string,
  params?: { category?: string; action?: string; label?: string; value?: number; [key: string]: unknown }
): void {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
}

/** Send a generic click event (category: engagement, action: click). */
export function trackClick(label: string, value?: number): void {
  event('click', {
    event_category: 'engagement',
    event_action: 'click',
    event_label: label,
    ...(value !== undefined && { value }),
  });
}
